import { useState } from "react";
import { Box, Divider, Grid } from "@mui/material";

import { JeopardyList } from "../components/JeopardyList";
import { JeopardyPanel } from "../components/JeopardyPanel";
import { JeoSeverity } from "../components/JeoSeverity";

export const Jeopardy = () => {

    const [selectedFilterCode, setSelectedFilterCode] = useState<string | null>(null);
    const [treeFilterCode, setTreeFilterCode] = useState<string | null>(null);

    return (
        <Box height={"100%"} display={'flex'} flexDirection={"column"}>
            <JeoSeverity selectedFilterCode={selectedFilterCode} onSelectedFilter={(filterCode) => setSelectedFilterCode(filterCode)} />
            <Divider />
            <Box flex={1} overflow={"hidden"}>
                <Grid container alignItems={"stretch"} height={"100%"} display={"flex"} flexDirection={"column"} flex={1}>
                    <Grid size={3} height={"100%"} display={"flex"} flexDirection={"column"}>
                        <JeopardyList selectedFilterCode={selectedFilterCode} onSelectedFilter={(filterCode) => setTreeFilterCode(filterCode)} treeFilterCode={treeFilterCode} />
                    </Grid>
                    <Divider orientation="vertical" />
                    <Grid size={9} height={"100%"} display={"flex"} flexDirection={"column"}>
                        <JeopardyPanel selectedFilterCode={selectedFilterCode} treeFilterCode={treeFilterCode} />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );

};